import type { SoundDesignDto } from '../../data/sound-design.dto.ts'
import type { SoundDesign } from '../models/sound-design.ts'

export const mapSoundDesignDtoToSoundDesign = (
  dto: SoundDesignDto
): SoundDesign => ({
  id: dto.alias,
  title: dto.name,
  duration: dto.durations.fixed_values.length
    ? dto.durations.fixed_values[0]
    : (dto.durations.min ?? dto.durations.max),
  genres: dto.tags.genres ?? [],
  moods: dto.tags.moods ?? [],
  soundSrc: dto.sample_url,
})
